import useAxiosService from './useAxiosService'
import { IDataList, ISearchQuery } from 'interfaces'
import { IResponse } from 'interfaces/services'
import { IDoctor } from 'pages/menuDoctor/interfaces'

export const useDoctorService = () => {
  const { post } = useAxiosService()
  const searchDoctor = async (
    query: ISearchQuery<any>
  ): Promise<IResponse<IDataList<IDoctor>>> => {
    const response: any = await post(`/clinic-doctor/search`, query)
    return {
      ...response,
      data: {
        data: response?.data?.doctors,
        totalItems: response?.data.total_items
      }
    } as IResponse<IDataList<IDoctor>>
  }

  return { searchDoctor }
}
